import { memo } from 'react';

import { cn } from '../../lib/styles';

type CardProps = React.HTMLAttributes<HTMLDivElement>;

export const CardTitle = ({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div className={cn('font-heading-3xl text-text-primary font-semibold text-center', className)} {...rest} />;
};

export const CardDescription = ({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div className={cn('font-heading-xl font-normal! text-text-primary text-center', className)} {...rest} />;
};

export const CardContent = ({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div className={cn('flex flex-col gap-2 mt-8', className)} {...rest} />;
};

const CardBase = ({ className, ...rest }: CardProps) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 py-14 px-16',
        'rounded-3xl border border-border-default bg-bg-sur-primary shadow-md',
        className,
      )}
      {...rest}
    />
  );
};

export const Card = memo(CardBase);
